export const homeTranslationEn = {
    more: "More about this app can be found at: ",
    rightClick: "Right click in tables for extra options!",
};
